<template>
  <a-modal
    :title="modalTitle"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <ls-api-table
      ref="dataTable"
      :columns="columns"
      :tableProps="tableProps"
      rowKey="id"
      :scroll="{ y: 290 }"
    >
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'switch'">
            <a-switch :checked="record[item.dataIndex] === 'Y'" disabled />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </ls-api-table>
  </a-modal>
</template>

<script>
import { apiScpMrpExceptionsList } from '@/api/scp/factoryCallMaterial/defaultMaterialGather'
import { generateLsTableResData } from '@/utils/util.js';
export default {
  props: {},
  data () {
    return {
      visible: false,
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpExceptionsList, true),
        pageCurrent: true
      },
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName'
        },
        {
          title: '仓库',
          dataIndex: 'subinventory'
        },
        {
          title: '批次',
          dataIndex: 'lotNumber'
        },
        {
          title: '是否冻结',
          dataIndex: 'frozenFlag',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'frozenFlag' },
          type: "switch"
        },
        {
          title: '是否有色差',
          dataIndex: 'colorDifferFlag',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'colorDifferFlag' },
          type: "switch"
        },
        {
          title: '盈余库存',
          dataIndex: 'quantity'
        }
      ],
      queryParams: {
        itemId: "",
        planVersion: ""
      },
      modalTitle: "查看其它供应"
    }
  },
  created () {},
  methods: {
    show (val) {
      this.modalTitle = `查看其它供应：${val.itemCode || ''} ${val.itemName || ''}`
      this.queryParams.itemId = val.itemId
      this.queryParams.planVersion = val.planVersion
      this.visible = true
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 表单重置
    reset () {
      this.queryParams = {
        itemId: "",
        planVersion: ""
      }
      this.$refs.dataTable.myDataSource = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body {
  height: 450px;
  overflow-y: scroll;
}
</style>
